import { Button } from "@similarweb/ui-components";

import type { FC } from "react";
import { i18nFilter } from "app/filters/i18nFilter";

export const ReactButton: FC<any> = (props) => {
    const label = i18nFilter()(props.text);
    return <Button {...props}>{label}</Button>;
};
export default ReactButton;
